import React from 'react';
import { ArrowLeft, Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';
import LogoutButton from '../common/LogoutButton';
import TokenBalance from '../TokenBalance';
import logo from '../../assets/imgs/logo.png';

type Props = {
  title: string;
  isConnected: boolean;
  onBack: () => void;
  onReconnect: () => void;
};

export const WorkshopHeader: React.FC<Props> = ({ title, isConnected, onBack, onReconnect }) => {
  return (
    <header className="h-14 bg-white border-b px-4 flex items-center justify-between shrink-0 relative">
      <div className="flex items-center gap-4">
        <Link to="/dashboard" className="text-gray-500 hover:text-brand-600">
          <ArrowLeft size={20} />
        </Link>
        <span className="font-bold text-gray-800">
          Workshop: {title}
        </span>
      </div>
      
      <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center h-14">
        <img src={logo} alt="Logo" className="h-full object-contain" />
      </div>
      
      <div className="flex items-center gap-4">
        <div className={`flex items-center gap-2 text-xs font-medium px-3 py-1 rounded-full ${isConnected ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
          {isConnected ? <Wifi size={14}/> : <WifiOff size={14}/>}
          <span>{isConnected ? "AI Online" : "Offline"}</span>
          {!isConnected && <button onClick={onReconnect} className="ml-2 hover:bg-red-200 p-1 rounded"><RefreshCw size={12}/></button>}
        </div>
        <TokenBalance />
        <LogoutButton />
      </div>
    </header>
  );
};
